import { removeSpecial } from "../../../../utils/tools";
import { EstadoContenido } from "../../../../utils/constants";

export const INFORMACION_UTIL_API = "informacion-util-dinamicas";

export const normalizeBloques = (data) => {
  if (Array.isArray(data?.bloques_informacion_util)) {
    return data.bloques_informacion_util;
  }

  return [];
};

const serializeImagen = (imagen) => {  if (!imagen) {
    return null;
  }

  return imagen.id ?? imagen;
};

export const serializeBloques = (bloques, { stripComponentIds = false } = {}) =>
  (bloques || []).map((bloque) => {
    const bloqueCopy = {
      titulo: bloque.titulo,
      imagen: serializeImagen(bloque.imagen),
      items: (bloque.items || []).map((item) => {
        const itemCopy = {
          titulo: item.titulo,
          descripcion: removeSpecial(item.descripcion || ""),
        };

        if (!stripComponentIds && !item.isNew && item.id) {
          itemCopy.id = item.id;
        }

        return itemCopy;
      }),
    };

    if (!stripComponentIds && !bloque.isNew && bloque.id) {
      bloqueCopy.id = bloque.id;
    }

    return bloqueCopy;
  });

export const prepareSubmitPayload = (values, bloques, extra = {}) => ({
  ...values,
  ...extra,
  bloques_informacion_util: serializeBloques(bloques),
});

export const prepareApprovePayload = (values, bloques, { draftId, ...extra } = {}) => {
  const {
    id,
    creado_por,
    actualizado_por,
    created_at,
    updated_at,
    localizations,
    created_by,
    updated_by,
    ...rest
  } = values;

  const payload = {
    ...rest,
    ...extra,
    estado: extra.estado ?? EstadoContenido.Publicado,
    bloques_informacion_util: serializeBloques(bloques, {
      stripComponentIds: true,
    }),
  };

  if (draftId != null && draftId !== "") {
    payload.id = draftId;
  }

  return payload;
};

export const resolveApproveTargetId = (draftId, idPadre) => {
  if (idPadre != null && idPadre !== "") {
    return idPadre;
  }

  return draftId;
};

export const shouldSkipDraftDeletion = (draftId, targetId) =>
  String(draftId) === String(targetId);
